module.exports = __webpack_public_path__ + "img/thinking.50cd4b08.svg";